import Api from "../../Utils/Axios";

export const GetFeedbackPaginate = async ({limit,page}) => {
  return new Promise(async (resolve, reject) => {
    try {
      resolve(await Api.get(`/admin/general/get-feedback?offset=${page}&limit=${limit}`));
    } catch (error) {
      reject(error);
    }
  })
}
